import ApplicationInitializer from '@application/js/application_initializer'

new ApplicationInitializer()
